"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var owa_options_core_1 = require("owa-options-core");
var owa_session_store_1 = require("owa-session-store");
var legacy_1 = require("satcheljs/lib/legacy");
var listViewBitFlagsUtil_1 = require("owa-bit-flags/lib/utils/listViewBitFlagsUtil");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(function isSenderImageOptionDirty(state) {
    var hideSenderImageViewStateOption = !listViewBitFlagsUtil_1.getIsBitSet(8 /* HideSenderImage */);
    var showSenderImageInListView = owa_options_core_1.getFallbackValueIfNull(state.optionState.showSenderImageInListView, hideSenderImageViewStateOption);
    return showSenderImageInListView !== hideSenderImageViewStateOption;
});
//# sourceMappingURL=isSenderImageOptionDirty.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-sender-image-option/lib/utils/isSenderImageOptionDirty.js
// module id = 5104
// module chunks = 2